module.exports = __webpack_public_path__ + "public/img/weixin.fd59d2cb.png";